/* 🤖 this file was generated by script */
export const wiconCheckSquare = {
  name: 'check_square',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7.5 12l3 3 6-6M7.8 21h8.4c1.68 0 2.52 0 3.16-.33a3 3 0 001.31-1.3c.33-.65.33-1.49.33-3.17V7.8c0-1.68 0-2.52-.33-3.16a3 3 0 00-1.3-1.31C18.71 3 17.87 3 16.2 3H7.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C3 5.29 3 6.13 3 7.8v8.4c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33z"/></svg>`,
};
